/* 恢复出厂*/

import {action} from 'mobx';
import {deviceReset} from '@/services/Home';
import DeviceStore from '@/stores/device';
import * as R from 'ramda';
import {message} from 'antd';
import UserStore from '@/stores/user';
import log from '@/utils/log';

class RestartStore {
  
  @action async deviceReset() {
    
    const ids =  DeviceStore.DeviceOperation.RebootStore.selectedIds
    
    const [error] = await deviceReset({
      ids: R.join(',', ids),
      groupId: UserStore.GroupStore.activeGroupId
    });
    
    if(error) {
      log({ pageId: 'P08', eventId: 'E0803',  ext: ''})
      return false;
    }
  
    log({ pageId: 'P08', eventId: 'E0800',  ext: ''})
  
    message.success('操作成功')
  
    await  DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});
  
    return true
    
  }
  
}

export default RestartStore;
